module.exports = __webpack_public_path__ + "static/img/yst.0aec5cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/partners/yst.png
// module id = 2pns
// module chunks = 3